import Swiper from 'swiper/bundle';

const MediaColumns = () => {
  const sliders = document.querySelectorAll('.media-columns__swiper');
  if (!sliders.length) return;

  const swiperInstances = new WeakMap();

  const initOrDestroySwiper = () => {
    sliders.forEach((slider) => {
      if (!(slider instanceof Element)) return;

      const slides = slider.querySelectorAll('.swiper-slide');
      const totalSlides = slides.length;

      
      

      const existingSwiper = swiperInstances.get(slider);

      const shouldDestroy =
        totalSlides === 1 ||
        window.innerWidth >= 1280 && slides.length <= 4;

      if (shouldDestroy) {
        if (existingSwiper && typeof existingSwiper.destroy === 'function') {
          existingSwiper.destroy(true, true);
          swiperInstances.delete(slider);
        }
        return;
      }

      if (!shouldDestroy && !existingSwiper) {
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 24,
          loop: false,
          pagination: {
            el: slider.querySelector('.media-columns__pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: slider.querySelector('.media-columns__nav--next'),
            prevEl: slider.querySelector('.media-columns__nav--prev'),
          },
          breakpoints: {
            1024: {
              slidesPerView: totalSlides < 3 ? totalSlides : 3
            },
            769: {
              slidesPerView: totalSlides < 2 ? totalSlides : 2
            },
          },
        });

        swiperInstances.set(slider, swiper);
      }
    });
  };

  // Initial load
  initOrDestroySwiper();

  // Responsive check
  window.addEventListener('resize', () => {
    initOrDestroySwiper();
  });
};

export default MediaColumns;
